import ContainerCodeNodeView from './ContainerCodeNodeView';
import {escapeHtml} from '../../Common/escapeHtml';

export default class MathBlockNodeView extends ContainerCodeNodeView {
    constructor(node, view, getPos) {
        super('math', node, view, getPos);
    }

    get displayNode() {
        return true;
    }

    get editorMode() {
        return "stex";
    }

    importAdditionalChunks() {
        import(/* webpackChunkName: "code-editor-mode/[request]" */ `codemirror/mode/${this.editorMode}/${this.editorMode}.js`);
    }

    renderer(codeText) {
        const renderLoader = document.getElementById('render-loader');
        renderLoader && renderLoader.classList.add('active');

        import(/* webpackChunkName: "tex-renderer" */ "katex/dist/katex.css");
        import(/* webpackChunkName: "tex-renderer" */ "katex/dist/katex.mjs").then(module => {
            const katex = module.default;

            try {
                this.replaceDomInnerHTML(katex.renderToString(codeText, {
                    throwOnError: this.displayNode,
                    displayMode: this.displayNode
                }));
                renderLoader && renderLoader.classList.remove('active');
            } catch (e) {
                if (e instanceof katex.ParseError) {
                    this.replaceDomInnerHTML(`<pre class="ui error"><code>${e.message ? escapeHtml(e.message) : ''}</code></pre>`);
                    renderLoader && renderLoader.classList.remove('active');
                } else {
                    throw e;
                }
            }
        }).catch(() => {
            if (this.displayNode) {
                this.replaceDomInnerHTML(`<pre class="ui error"><code>Unable to load TeX renderer, please try again.</code></pre>`);
            } else {
                this.replaceDomInnerHTML(`<span class="ui error text"><code>${codeText ? escapeHtml(codeText) : ''}</code></span>`);
            }
            renderLoader && renderLoader.classList.remove('active');
        });
    }
}